import gql from 'graphql-tag';

export const UN_COMPLETE_STAGE = gql`
  mutation UnCompleteStage(
    $input: UnCompleteBusinessProcessFlowStageInput!
    $parentId: ID!
    $parentType: BPFLinkType!
  ) {
    bpf {
      result: unCompleteStage(input: $input) {
        error
        success
        entity {
          unCompleted {
            businessProcessFlowStageId
            name
            fieldValues(parentId: $parentId, parentType: $parentType) {
              id
              isCompleted
              completedById
              completedDateTime
              completedBy {
                id
                fullName
              }
            }
          }

          previous {
            businessProcessFlowStageId
            name
            fieldValues(parentId: $parentId, parentType: $parentType) {
              id
              isCompleted
              completedById
              completedDateTime
              completedBy {
                id
                fullName
              }
            }
          }
        }
      }
    }
  }
`;
